module.exports = __webpack_public_path__ + "img/music-player-details3.16a5600b.png";